// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-fit[data-v-029d93cf] {\n  width: -moz-fit-content;\n  width: fit-content;\n}", "",{"version":3,"sources":["webpack://./resources/js/v2/components/app-menu.vue"],"names":[],"mappings":"AACA;EACC,uBAAA;EAAA,kBAAA;AAAD","sourcesContent":["\n.w-fit {\n\twidth: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
